var React = require('react');

var LineD3 = require('./LineD3');

var Line = React.createClass({
    propTypes: {
        baselines: React.PropTypes.array,
        series: React.PropTypes.array,

        width: React.PropTypes.number.isRequired,
        height: React.PropTypes.number.isRequired
    },

    getDefaultProps: function() {
        return {
            baselines: [],
            series: []
        };
    },

    getInitialState: function () {
        return {
            d3: null
        }
    },

    componentDidMount: function () {
        this.processChart();
    },

    componentDidUpdate: function() {
        this.processChart();
    },

    processChart: function () {
        var chart = this.state.d3;
        if (!chart) {
            var el = this.refs.el.getDOMNode();
            this.state.d3 = chart = new LineD3(el, {
                width: this.props.width,
                height: this.props.height
            });
        }

        if (this.props.series.length) {
            chart.updateSize(this.props.width, this.props.height);
            chart.update(this.props.series, this.props.baselines);
        }
    },

    render: function() {
        return <div ref="el" className="chartline"></div>;
    }
});
module.exports = Line;



// WEBPACK FOOTER //
// ./app/components/Chart/Line.js